import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import cardOrderServices from '@src/services/cardOrder.services';
import { setCardList } from './cardOrderDetailtsSlice';
import dayjs from '@src/utils/day';
import mobilExpressServices from '@src/services/mobilExpress.services';
import { VouIdCode } from '../enums';

const cardOrderServicesGetOrderCalculate = async (
  customerId,
  vouId,
  orderTypeId,
  paymentReferenceType,
  id,
) => {
  return await cardOrderServices.getOrderCalculateAmountGetList({
    customerId,
    vouId,
    orderTypeId,
    paymentReferenceType,
    id,
  });
};
export const getCurrentCardOrder = createAsyncThunk(
  'getCurrentCardOrder',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      const card = await cardOrderServices.getCurrentCardOrder({
        customerId,
        vouId: body?.vouId ?? 1,
      });
      const getOrderCalculateAmountGetList = await cardOrderServicesGetOrderCalculate(
        customerId,
        card.data.vouId,
        card.data.orderType,
        1,
        card.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        card.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        card.data.totalPaymentAmount = 0;
      }
      if (body?.vouId === VouIdCode.Compliments && card.data.cardType === 2) {
        card.data.cardType = 1;
      }
      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCardOrders = createAsyncThunk(
  'getCardOrders',
  async ({ id }, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      const currentId = await getState()?.cardOrder?.currentCardOrder?.id;
      if (!id && !currentId) {
        await dispatch(getCurrentCardOrder());
      }
      const card = await cardOrderServices.getCardOrders({ id: id || currentId });
      const getOrderCalculateAmountGetList = await cardOrderServicesGetOrderCalculate(
        customerId,
        card.data.vouId,
        card.data.orderType,
        1,
        card.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        card.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        card.data.totalPaymentAmount = 0;
      }
      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardOrdersSave = createAsyncThunk(
  'cardOrdersSave',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      delete body.totalPaymentAmount;
      if (body.cardType === 2) {
        body.cardType = 1;
      }
      const card = await cardOrderServices.cardOrdersSave({ entity: { ...body, customerId } });
      const getOrderCalculateAmountGetList = await cardOrderServicesGetOrderCalculate(
        customerId,
        card.data.vouId,
        card.data.orderType,
        1,
        card.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        card.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        card.data.totalPaymentAmount = 0;
      }
      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getDraftedCardOrders = createAsyncThunk(
  'getDraftedCardOrders',
  async ({ pageNumber, pageSize }, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }

      const action = await cardOrderServices.getDraftedCardOrders({
        customerId,
        pageNumber,
        pageSize,
      });

      return action;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardOrdersUpdate = createAsyncThunk(
  'cardOrdersUpdate',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      if (!body?.id) {
        return rejectWithValue({
          message: 'Kayıt bulunamadı.',
        });
      }
      delete body.totalPaymentAmount;

      if (body.orderStatus === 90 && !body.cardBin) {
        const { selectedStoredCard } = (await getState()).mobilExpress;
        if (selectedStoredCard) {
          const cards =
            (
              await mobilExpressServices.storedCardGetAll({
                customerId: body.customerId,
                VouId: body.vouId ?? 1,
              })
            )?.data?.cardList || [];
          body.cardToken = selectedStoredCard;
          const cardBin =
            cards
              .find((card) => card.cardToken === selectedStoredCard)
              ?.maskedCardNumber?.slice(0, 6) || '';
          if (cardBin) {
            body.cardBin = cardBin;
          }
        }
      }

      if (body.cardBin === '') {
        body.cardBin = null;
      }

      if (body.dontSendBinAndToken) {
        body.cardBin = null;
        body.cardToken = null;
      }

      const card = await cardOrderServices.cardOrdersUpdate({ entity: { ...body, customerId } });
      const getOrderCalculateAmountGetList = await cardOrderServicesGetOrderCalculate(
        customerId,
        card.data.vouId,
        card.data.orderType,
        1,
        card.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        card.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        card.data.totalPaymentAmount = 0;
      }
      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardOrdersDelete = createAsyncThunk(
  'cardOrdersDelete',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const currentCardOrderId = await getState()?.cardOrder?.currentCardOrder?.id;
      if (!currentCardOrderId) {
        return rejectWithValue({
          message: 'Kayıt bulunamadı.',
        });
      }
      const response = await cardOrderServices.cardOrdersDelete({ id: currentCardOrderId });
      await dispatch(setCardList([]));
      await dispatch(getCurrentCardOrder());
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);
export const pendingCardOrderDelete = createAsyncThunk(
  'pendingCardOrderDelete',
  async (body, { rejectWithValue }) => {
    try {
      return await cardOrderServices.cardOrdersDelete({
        id: body?.id,
        CancelledByUser: body?.CancelledByUser || false,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteUnCompleted = createAsyncThunk(
  'deleteUnCompleted',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await cardOrderServices.deleteUnCompleted(body?.vouId);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCardOrderForThanksPage = createAsyncThunk(
  'getCardOrderForThanksPage',
  async ({ id, vouId }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      const provisionDay = await getState()?.mobilExpress?.payLaterDayForThanksPage;

      return await cardOrderServices.getCardOrderForThanksPage(id, customerId, provisionDay, vouId);
    } catch (error) {
      console.error(error);
      return rejectWithValue(error?.data);
    }
  },
);

export const getCardOrdersForStatusWithUpdaterUserName = createAsyncThunk(
  'getCardOrdersForStatusWithUpdaterUserName',
  async (body, { rejectWithValue }) => {
    try {
      return await cardOrderServices.getCardOrdersForStatusWithUpdaterUserName({ data: body });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  activeStep: 0,
  draftedCardOrders: [],
  cardOrderList: [],
  currentCardOrder: {},
  draftedTableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
  thanksPageCardOrderTextList: {},
  cardOrderPopupDigital: false,
};

const orderSucceeded = (state, action) => {
  state.currentCardOrder = action?.payload?.data;
  if (action?.payload?.data?.orderStatus === 10) {
    state.activeStep = 1;
  } else if (action?.payload?.data?.orderStatus === 20) {
    state.activeStep = 2;
  } else if (
    action?.payload?.data?.orderStatus === 90 ||
    action?.payload?.data?.orderStatus === 100 ||
    action?.payload?.data?.orderStatus === 15
  ) {
    state.activeStep = 3;
  } else {
    state.activeStep = 0;
  }
  try {
    if (state.activeStep > 0 && action?.payload?.data?.totalPrice > 0) {
      const now = new Date();
      const today = dayjs(now.toDateString());
      if (state.currentCardOrder?.cardActivationDate) {
        const cardActivationDate = dayjs(state.currentCardOrder?.cardActivationDate);
        const isBefore = cardActivationDate.isBefore(today, 'day');
        if (isBefore) {
          state.activeStep = 0;
        }
      }
    }
  } catch (e) {}
};

const orderFailed = (state) => {
  state.currentCardOrder = {};
  state.activeStep = 0;
};

export const cardOrderSlice = createSlice({
  name: 'cardOrder',
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    nextStep: (state) => {
      state.activeStep = state.activeStep + 1;
    },
    prevStep: (state) => {
      state.activeStep = state.activeStep - 1;
    },
    setCurrentCardOrder: (state, action) => {
      state.currentCardOrder = {
        ...state.currentCardOrder,
        ...action.payload,
      };
    },
    reset: (state) => {
      state.activeStep = 0;
      state.currentCardOrder = {};
    },
    setCardOrderPopupDigital: (state, action) => {
      state.cardOrderPopupDigital = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentCardOrder.fulfilled, (state, action) => {
      orderSucceeded(state, action);
    });
    builder.addCase(getCurrentCardOrder.rejected, (state) => {
      orderFailed(state);
    });
    builder.addCase(getCardOrders.fulfilled, (state, action) => {
      orderSucceeded(state, action);
    });
    builder.addCase(getCardOrders.rejected, (state) => {
      orderFailed(state);
    });
    builder.addCase(cardOrdersSave.fulfilled, (state, action) => {
      orderSucceeded(state, action);
    });
    builder.addCase(cardOrdersSave.rejected, (state, action) => {
      orderFailed(state);
    });
    builder.addCase(cardOrdersUpdate.fulfilled, (state, action) => {
      orderSucceeded(state, action);
    });
    builder.addCase(cardOrdersUpdate.rejected, (state) => {
      orderFailed(state);
    });
    builder.addCase(getDraftedCardOrders.fulfilled, (state, action) => {
      state.draftedCardOrders = action?.payload?.data?.items || [];
      state.draftedTableProperty = action?.payload?.data?.pagedProperty || {};
    });
    builder.addCase(getDraftedCardOrders.rejected, (state, action) => {
      state.draftedCardOrders = [];
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
    builder.addCase(getCardOrderForThanksPage.fulfilled, (state, action) => {
      state.thanksPageCardOrderTextList = action?.payload?.data;
    });
    builder.addCase(getCardOrdersForStatusWithUpdaterUserName.fulfilled, (state, action) => {
      state.cardOrderList = action?.payload?.data?.items || [];
      state.draftedTableProperty = action?.payload?.data?.pagedProperty || {};
    });
    builder.addCase(getCardOrdersForStatusWithUpdaterUserName.rejected, (state, action) => {
      state.cardOrderList = [];
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
  },
});

export const {
  nextStep,
  prevStep,
  setCurrentCardOrder,
  setActiveStep,
  reset,
  setCardOrderPopupDigital,
} = cardOrderSlice.actions;
